module.exports = __webpack_public_path__ + "img/3.29e9dbe6.jpg";